import axios from 'axios';
import { postData } from '../../services/axiosUtils';

const asListResponse = (data: any) => {
  if (Array.isArray(data)) {
    return { hasError: false, records: data, errorMessages: [] };
  }
  if (data?.records) return data;
  return { hasError: false, records: data ? [data] : [], errorMessages: [] };
};

const wrapEntity = (data: any) =>
  data?.hasError !== undefined
    ? data
    : { hasError: false, result: data, errorMessages: [] };

const roleCatalogService = {
  listTemplates: () =>
    axios.get(`/api/role-catalog/templates`).then((r) => asListResponse(r.data)),
  createTemplate: (entity: any) => {
    const { id, ...rest } = entity ?? {};
    const data = id ? entity : rest;
    return postData({ url: `/api/role-catalog/templates`, data }).then(wrapEntity);
  },
  updateTemplate: (entity: any) =>
    postData({
      url: `/api/role-catalog/templates`,
      data: entity,
      method: 'PUT',
    }).then(wrapEntity),
  listPermissions: (id: any) =>
    axios
      .get(`/api/role-catalog/templates/${id}/permissions`)
      .then((r) => asListResponse(r.data)),
  setPermissions: (id: any, permissions: string[]) =>
    postData({
      url: `/api/role-catalog/templates/${id}/permissions`,
      data: permissions,
      method: 'PUT',
    }).then(wrapEntity),
  listEnabled: () =>
    axios.get(`/api/role-catalog/enabled`).then((r) => asListResponse(r.data)),
};

export default roleCatalogService;
